module.exports = __webpack_public_path__ + "static/media/scarf-gray.c176eedf.svg";